import { createQuery, request } from '@luna/api';

import type { QueryAllResponse } from './useContacts';
import { getCDMUrl } from './ContactDataManagementApiService';
import { transformContactsToNewStructure } from './useContactsService';

export enum ContactsFilter {
    PIN_DELIVERY = 'PIN_DELIVERY',
    CARD_DELIVERY = 'CARD_DELIVERY',
}

export const [useFilteredContacts] = createQuery({
    name: 'contact-data-management/filtered-contacts',
    cacheKey: (filterFor) => filterFor,
    payloadCreator: async (filterFor: ContactsFilter) => {
        const response = await request<QueryAllResponse>(`${getCDMUrl()}?filterFor=${filterFor}`);
        const contacts = response.contacts ?? [];

        return transformContactsToNewStructure(contacts);
    },
});
